
import { AiStudioComponent } from './ai-studio/ai-studio.component';
import { Shortcut } from './models/shortcut.model';

export const shortcuts: Shortcut[] = [
    {
        command: '/list sellouts (ls)',
        description: 'View sellout records.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('sellout/list')
    },
    {
        command: '/create or upload promo plan (cpp, upp)',
        description: 'Upload a promo plan Excel file.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('promo-plan/upload')
    },
    {
        command: '/list promo plan (lpp)',
        description: 'View a promo plan.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('promo-plan/list')
    },
    {
        command: '/create settlement (cst)',
        description: 'Create a new settlement.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('settlement/add')
    },
    {
        command: '/view settlement (vst)',
        description: 'View a specific settlement.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('settlement/view/1234')
    },
    {
        command: '/list settlements (lst)',
        description: 'View a list of all settlements.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('settlement/list')
    },
    {
        command: '/archive sessions (as)',
        description: 'Search and view archived chat sessions.',
        action: () => window.open('/session-archive', '')
    },
    {
        command: '/status workflow manager',
        description: 'Configure Apporval Workflows',
        action: (component: AiStudioComponent) => component.navigateToCanvas('status-workflow-manager')
    },
    {
        command: 'users/list',
        description: 'View Users List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('users/list')
    },
    {
        command: 'roles/list',
        description: 'View Roles List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('roles/list')
    },
    {
        command: 'branches/list',
        description: 'View Brnaches List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('branches/list')
    },
    {
        command: 'businessUnit/list',
        description: 'View Business Unit List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('businessUnit/list')
    },
    {
        command: 'brand/list',
        description: 'View Brands List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('brand/list')
    },
    {
        command: 'sub-brand/list',
        description: 'View Sub Brands List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('sub-brand/list')
    },
    {
        command: 'supplier/list',
        description: 'View Suppliers List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('supplier/list')
    },
    {
        command: 'supplier-site/list',
        description: 'View Supplier Sites List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('supplier-site/list')
    },
    {
        command: 'business/list',
        description: 'View Business List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('business/list')
    },
    {
        command: 'customer/list',
        description: 'View Customer List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('customer/list')
    },
    {
        command: 'locations/list',
        description: 'View Locations List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('locations/list')
    },
    {
        command: 'activity-types/list',
        description: 'View Activity Types List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('activity-types/list')
    },
    {
        command: 'items/list',
        description: 'View Items List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('items/list')
    },
    {
        command: 'customer-item/list',
        description: 'View Customer Items List',
        action: (component: AiStudioComponent) => component.navigateToCanvas('customer-item/list')
    },
    {
        command: 'customer-item/create',
        description: 'Create a Customer Item mapping',
        action: (component: AiStudioComponent) => component.navigateToCanvas('customer-item/create')
    },
    {
        command: 'customer-item/edit',
        description: 'Edit a Customer Item mapping by ID',
        action: (component: AiStudioComponent) => component.navigateToCanvas('customer-item/edit/1')
    },
    {
        command: '/create Fixed Rebate (cfr)',
        description: 'Create a new fixed rebate.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('rebate/create/fixed-rebate')
    },
    {
        command: '/create Fixed Rebate by site (cfr)',
        description: 'Create a new fixed rebate by site.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('rebate/create/fixed-by-site-rebate')
    },
    {
        command: '/create Progressive Rebate (cpr)',
        description: 'Create a new progressive rebate .',
        action: (component: AiStudioComponent) => component.navigateToCanvas('rebate/create/rebate')
    },
    {
        command: '/list rebates (lct)',
        description: 'View a list of all rebates.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('rebate/list')
    },
    {
        command: '/list rebate Details (Multi Export)',
        description: 'View a list of all rebate details.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('rebate/multi-export')
    },
    {
        command: '/list Rebate Results (lrr)',
        description: 'View a list of all rebate results.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('rebate-results/list')
    },
    {
        command: '/list Claim Results (lcr)',
        description: 'View a list of all claim results.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('claim-results/list')
    },
    {
        command: '/list Contract Claim (lcc)',
        description: 'View a list of all contract claims.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('claim-contract/list')
    },
    {
        command: '/create Contract Claim (lcc)',
        description: 'Create a new contract claim.',
        action: (component: AiStudioComponent) => component.navigateToCanvas('claim-contract/create')
    },
    {
        command: '/help',
        description: 'Show help for available skills.',
        insertText: '@{Tamkeen} How you can help me?'
    },
];
